import request from '@/utils/request'

export function getAgencyList(query) {
  return request({
    url: '/Agency/getAgencyList',
    method: 'get',
    params: query,
  })
}

export function getAnAgencyByCode(query) {
  return request({
    url: '/Agency/getAnAgencyByCode',
    method: 'get',
    params: query,
  })
}

export function getAnAgencyAvatarByCode(query) {
  return request({
    url: '/Agency/getAnAgencyAvatarByCode',
    method: 'get',
    params: query,
  })
}

export function getAgencyTravelOpinionSurveyOptions(query) {
  return request({
    url: '/Agency/getAgencyTravelOpinionSurveyOptions',
    method: 'get',
    params: query,
  })
}

export function saveAgency(data) {
  return request({
    url: '/Agency/saveAgency',
    method: 'post',
    data,
  })
}

export function getTourLeaderList(query) {
  return request({
    url: '/Agency/getTourLeaderList',
    method: 'get',
    params: query,
  })
}

export function getAnTourLeaderByID(query) {
  return request({
    url: '/Agency/getAnTourLeaderByID',
    method: 'get',
    params: query,
  })
}

export function saveTourLeaderInfo(data) {
  return request({
    url: '/Agency/saveTourLeaderInfo',
    method: 'post',
    data,
  })
}

export function getAgencyTravels(query) {
  return request({
    url: '/Agency/getAgencyTravels',
    method: 'get',
    params: query,
  })
}

export function getAgencyTravelsAndOtherInformation(data) {
  return request({
    url: '/Agency/getAgencyTravelsAndOtherInformation',
    method: 'post',
    data,
  })
}

export function getAgencyTravelsOpinionSurveies(query) {
  return request({
    url: '/Agency/getAgencyTravelsOpinionSurveies',
    method: 'get',
    params: query,
  })
}

export function getAgencyOpinionSurvey(query) {
  return request({
    url: '/Agency/getAgencyOpinionSurvey',
    method: 'get',
    params: query,
  })
}

export function saveAgencyAvatar(data) {
  return request({
    url: '/Agency/saveAgencyAvatar',
    method: 'post',
    data,
  })
}

export function setAgencyOpinionSurveyDefault(data) {
  return request({
    url: '/Agency/setAgencyOpinionSurveyDefault',
    method: 'post',
    data,
  })
}

export function createSurveyQueryToTravel(data) {
  return request({
    url: '/Agency/createSurveyQueryToTravel',
    method: 'post',
    data,
  })
}

export function settingShowToApp(data) {
  return request({
    url: '/Agency/settingShowToApp',
    method: 'post',
    data,
  })
}

export function deleteOpinionSurvery(data) {
  return request({
    url: '/Agency/deleteOpinionSurvery',
    method: 'post',
    data,
  })
}

export function copyTravelCarryItems(data) {
  return request({
    url: '/Agency/copyTravelCarryItems',
    method: 'post',
    data,
  })
}

export function getTourNumbers(query) {
  return request({
    url: '/Agency/getTourNumbers',
    method: 'get',
    params: query,
  })
}

export function getRequestApplyOption(query) {
  return request({
    url: '/Agency/getRequestApplyOption',
    method: 'get',
    params: query,
  })
}

export function saveAgencyRecordRequest(data) {
  return request({
    url: '/Agency/saveAgencyRecordRequest',
    method: 'post',
    data,
  })
}

export function getAgencyRecordRequestList(query) {
  return request({
    url: '/Agency/getAgencyRecordRequestList',
    method: 'get',
    params: query,
  })
}

export function getAgencyAnSocialNetworkingLink(query) {
  return request({
    url: '/Agency/getAgencyAnSocialNetworkingLink',
    method: 'get',
    params: query,
  })
}

export function getAgencySocialNetworkingLink(query) {
  return request({
    url: '/Agency/getAgencySocialNetworkingLink',
    method: 'get',
    params: query,
  })
}

export function getAgencySerialNumber(query) {
  return request({
    url: '/Agency/getAgencySerialNumber',
    method: 'get',
    params: query,
  })
}

export function setLeaderContract(data) {
  return request({
    url: '/Agency/setLeaderContract',
    method: 'post',
    data,
  })
}

export function getCheckOutYearMonth(query) {
  return request({
    url: '/Agency/getCheckOutYearMonth',
    method: 'get',
    params: query,
  })
}

export function getAgencyReceivable(data) {
  return request({
    url: '/Agency/getAgencyReceivable',
    method: 'post',
    data,
  })
}

export function getAgencies(data) {
  return request({
    url: '/Agency/getAgencies',
    method: 'post',
    data,
  })
}

export function savePropertyDocuments(data) {
  return request({
    url: '/Agency/savePropertyDocuments',
    method: 'post',
    data,
  })
}

export function deleteResultForm(data) {
  return request({
    url: '/Agency/deleteResultForm',
    method: 'post',
    data,
  })
}

export function savePaymentInvoiceNote(data) {
  return request({
    url: '/Agency/savePaymentInvoiceNote',
    method: 'post',
    data,
  })
}

export function getTravelersDetails(query) {
  return request({
    url: '/Agency/getTravelersDetails',
    method: 'get',
    params: query,
  })
}

export function getTaiwanCitiesOption(query) {
  return request({
    url: '/Agency/getTaiwanCitiesOption',
    method: 'get',
    params: query,
  })
}

export function getTaiwanCitiesZipCode(query) {
  return request({
    url: '/Agency/getTaiwanCitiesZipCode',
    method: 'get',
    params: query,
  })
}

export function getAgencyMembers(data) {
  return request({
    url: '/Agency/getAgencyMembers',
    method: 'post',
    data,
  })
}

export function getAgencyNoticeStyleType(query) {
  return request({
    url: '/Agency/getAgencyNoticeStyleType',
    method: 'get',
    params: query,
  })
}

export function getAgencyNoticeType(query) {
  return request({
    url: '/Agency/getAgencyNoticeType',
    method: 'get',
    params: query,
  })
}

export function saveAgencyNoticeCommon(data) {
  return request({
    url: '/Agency/saveAgencyNoticeCommon',
    method: 'post',
    data,
  })
}

export function getAgencyNoticeCommon(query) {
  return request({
    url: '/Agency/getAgencyNoticeCommon',
    method: 'get',
    params: query,
  })
}

export function deleteAgencyNoticeCommon(data) {
  return request({
    url: '/Agency/deleteAgencyNoticeCommon',
    method: 'post',
    data,
  })
}

export function saveAgencyNotice(data) {
  return request({
    url: '/Agency/saveAgencyNotice',
    method: 'post',
    data,
  })
}

export function getAgencyRoles(query) {
  return request({
    url: '/Agency/getAgencyRoles',
    method: 'get',
    params: query,
  })
}

export function getAgencyNotice(data) {
  return request({
    url: '/Agency/getAgencyNotice',
    method: 'post',
    data,
  })
}

export function deleteAgencyNotice(data) {
  return request({
    url: '/Agency/deleteAgencyNotice',
    method: 'post',
    data,
  })
}

export function saveAgencyNoticeType(data) {
  return request({
    url: '/Agency/saveAgencyNoticeType',
    method: 'post',
    data,
  })
}

export function deleteAgencyNoticeType(data) {
  return request({
    url: '/Agency/deleteAgencyNoticeType',
    method: 'post',
    data,
  })
}

export function getAgencyOptions(query) {
  return request({
    url: '/Agency/getAgencyOptions',
    method: 'get',
    params: query,
  })
}

export function getAgencyCustomerComplaint(data) {
  return request({
    url: '/Agency/getAgencyCustomerComplaint',
    method: 'post',
    data,
  })
}

export function deleteAgencyCustomerComplaint(data) {
  return request({
    url: '/Agency/deleteAgencyCustomerComplaint',
    method: 'post',
    data,
  })
}

export function saveAgencyCustomerComplaint(data) {
  return request({
    url: '/Agency/saveAgencyCustomerComplaint',
    method: 'post',
    data,
  })
}

//取得該帳號之所有客訴訊息
export function getUserCustomerComplaintMessage(data) {
  return request({
    url: '/Agency/getUserCustomerComplaintMessage',
    method: 'post',
    data,
  })
}

export function getCustomerComplaintNotify() {
  return request({
    url: '/Agency/getCustomerComplaintNotify',
    method: 'get',
  })
}

//標記已讀並取回所有訊息
export function markMessageAsReadComplaint(data) {
  return request({
    url: '/Agency/markMessageAsReadComplaint',
    method: 'post',
    data,
  })
}

// 取得旅行社試用截止日期
export function getAgencyFreeDate(query) {
  return request({
    url: '/Agency/getAgencyFreeDate',
    method: 'get',
    params: query,
  })
}

// 設定旅行社試用截止日期
export function setAgencyFreeDate(data) {
  return request({
    url: '/Agency/setAgencyFreeDate',
    method: 'post',
    data,
  })
}

// 取得旅客管理資料
export function getTravelersManagement(query) {
  return request({
    url: '/Agency/getTravelersManagement',
    method: 'get',
    params: query,
  })
}

// 設定旅客管理客訴備註
export function setTravelersManagement(data) {
  return request({
    url: '/Agency/setTravelersManagement',
    method: 'post',
    data,
  })
}

// 設定折抵金額人數
export function setAgencyPromotionalPlan(data) {
  return request({
    url: '/Agency/PromotionalPlan',
    method: 'post',
    data,
  })
}

// 刪除設定折抵金額人數
export function deleteAgencyPromotionalPlan(data) {
  return request({
    url: '/Agency/PromotionalPlan',
    method: 'delete',
    params: data,
  })
}

// 列表對外合約基本檔
export function getSideContracts(query) {
  return request({
    url: '/contract/outSideContracts',
    method: 'get',
    params: query,
  })
}

// 儲存對外合約基本檔
export function saveSideContract(data) {
  return request({
    url: '/file/sideContractsUpload',
    method: 'post',
    data,
  })
}

// 刪除對外合約基本檔
export function deleteSideContract(data) {
  return request({
    url: '/contract/deleteContract',
    method: 'post',
    data,
  })
}

// 產生對外簽署合約
export function generateSideContract(data) {
  return request({
    url: '/contract/generateOutContract',
    method: 'post',
    data,
  })
}

// 刪除對外簽署合約
export function deleteSideSignContract(data) {
  return request({
    url: '/contract/deleteSignContract',
    method: 'post',
    data,
  })
}

// 儲存AI設定
export function savaAISetting(data) {
  return request({
    url: '/Agency/savaAISetting',
    method: 'post',
    data,
  })
}

// 語音導覽設定
export function savaVoiceTranslation(data) {
  return request({
    url: '/Agency/savaVoiceTranslation',
    method: 'post',
    data,
  })
}
